import { StaticApiState } from './types/static-file.types';
import { defaultApiState } from '@/store/types/general.types';

export const staticFileState: StaticApiState = {
  apiState: {
    getSignedUrlForUpload: defaultApiState
  },
  signedUrlData: undefined
};
